export const LANGUAGES = [
  // Indian Languages
  { code: "en", name: "English (India)" },
  { code: "hi", name: "Hindi" },
  // { code: "ta-IN", name: "Tamil" },
  // { code: "bn-IN", name: "Bengali" },
  // { code: "kn-IN", name: "Kannada" },
  // { code: "ml-IN", name: "Malayalam" },
  // { code: "mr-IN", name: "Marathi" },
  // { code: "or-IN", name: "Odia" },
  // { code: "pa-IN", name: "Punjabi" },
  // { code: "te-IN", name: "Telugu" },
  // { code: "gu-IN", name: "Gujarati" },
  
  // International Languages
  // { code: "en-US", name: "English (US)" },
  // { code: "en-GB", name: "English (UK)" },
  // { code: "en-AU", name: "English (Australia)" },
  // { code: "en-CA", name: "English (Canada)" },
  { code: "es-ES", name: "Spanish (Spain)" },
  { code: "es-MX", name: "Spanish (Mexico)" },
  { code: "es-AR", name: "Spanish (Argentina)" },
  { code: "fr-FR", name: "French (France)" },
  { code: "fr-CA", name: "French (Canada)" },
  { code: "de-DE", name: "German" },
  { code: "it-IT", name: "Italian" },
  { code: "pt-BR", name: "Portuguese (Brazil)" },
  { code: "pt-PT", name: "Portuguese (Portugal)" },
  { code: "ru-RU", name: "Russian" },
  { code: "ja-JP", name: "Japanese" },
  { code: "ko-KR", name: "Korean" },
  { code: "zh-CN", name: "Chinese (Simplified)" },
  { code: "zh-TW", name: "Chinese (Traditional)" },
  { code: "ar-SA", name: "Arabic (Saudi Arabia)" },
  { code: "ar-EG", name: "Arabic (Egypt)" },
  { code: "nl-NL", name: "Dutch" },
  { code: "sv-SE", name: "Swedish" },
  { code: "no-NO", name: "Norwegian" },
  { code: "da-DK", name: "Danish" },
  { code: "fi-FI", name: "Finnish" },
  { code: "pl-PL", name: "Polish" },
  { code: "tr-TR", name: "Turkish" },
  { code: "th-TH", name: "Thai" },
  { code: "vi-VN", name: "Vietnamese" },
  { code: "id-ID", name: "Indonesian" },
  { code: "ms-MY", name: "Malay" },
  { code: "tl-PH", name: "Filipino" },
  { code: "uk-UA", name: "Ukrainian" },
  { code: "cs-CZ", name: "Czech" },
  { code: "hu-HU", name: "Hungarian" },
  { code: "ro-RO", name: "Romanian" },
  { code: "bg-BG", name: "Bulgarian" },
  { code: "hr-HR", name: "Croatian" },
  { code: "sk-SK", name: "Slovak" },
  { code: "sl-SI", name: "Slovenian" },
  { code: "et-EE", name: "Estonian" },
  { code: "lv-LV", name: "Latvian" },
  { code: "lt-LT", name: "Lithuanian" },
  { code: "el-GR", name: "Greek" },
  { code: "he-IL", name: "Hebrew" },
  { code: "fa-IR", name: "Persian" },
  { code: "ur-PK", name: "Urdu" },
  { code: "sw-KE", name: "Swahili" },
  { code: "am-ET", name: "Amharic" },
  { code: "zu-ZA", name: "Zulu" },
  { code: "af-ZA", name: "Afrikaans" },
  { code: "is-IS", name: "Icelandic" },
  { code: "ga-IE", name: "Irish" },
  { code: "cy-GB", name: "Welsh" },
  { code: "mt-MT", name: "Maltese" },
  { code: "sq-AL", name: "Albanian" },
  { code: "mk-MK", name: "Macedonian" },
  { code: "sr-RS", name: "Serbian" },
  { code: "bs-BA", name: "Bosnian" },
  { code: "ca-ES", name: "Catalan" },
  { code: "eu-ES", name: "Basque" },
  { code: "gl-ES", name: "Galician" },
];
